"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.firstDefined = firstDefined;
/**
 * Helper function to return the first value that is not `undefined`.
 * Similar to the Nullish coalescing operator (??).
 * But unlike `??` it will consider `null` as a valid defined value.
 */
function firstDefined(...args) {
    return args.find((v) => v !== undefined);
}
//# sourceMappingURL=FirstDefinedValue.js.map